module.exports = __webpack_public_path__ + "img/imgVirtualTryOn05.8e6c3794.png";